<template>
  <filter-wrapper>
    <z-form ref="form" @submit.prevent.native="submit">
      <div class="filter__row">
        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('voice.stats.general.filter.voice_stats.trunk.title') }}
          </label>
          <z-form-input
            class="filter__item__body"
            :rules="{ required: true }"
            :show_errors="false"
            mode="aggressive"
          >
            <trunks-input-select-trunk v-model="form.trunk_id" :trunks="trunks" />
          </z-form-input>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('voice.stats.general.filter.voice_stats.destination.title') }}
          </label>
          <div class="filter__item__body">
            <country-select v-model="form.destination" :multiple="detailed" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('voice.stats.general.filter.voice_stats.source.title') }}
          </label>
          <div class="filter__item__body">
            <i-input v-model="form.source" type="number" :clearable="true" @on-clear="submit" />
          </div>
        </div>

        <div class="filter__item col-3">
          <label class="filter__item__title">
            {{ $t('voice.stats.general.filter.voice_stats.destination_b_number.title') }}
          </label>
          <div class="filter__item__body">
            <i-input
              v-model="form.destination_b_number"
              type="number"
              :clearable="true"
              @on-clear="submit"
            />
          </div>
        </div>
      </div>
      <div class="filter__row">
        <div class="filter__item filter__item--datepicker col-6">
          <label class="filter__item__title">
            {{ $t('shared.component.filter.period') }}
          </label>
          <z-form-input class="filter__item__body">
            <date-range-picker v-model="form.date" :clearable="true" />
          </z-form-input>
        </div>

        <div class="filter__row ml-auto">
          <div class="filter__item filter__item--button">
            <i-button html-type="submit" type="primary">
              {{ $t('shared.component.filter.show_result') }}
            </i-button>
          </div>
          <div v-if="is_export_allowed" class="filter__item filter__item--button">
            <i-button
              html-type="submit"
              type="primary"
              @click="createExport"
            >
              {{ $t('shared.component.export_report.export_modal') }}
            </i-button>
          </div>
        </div>
      </div>
    </z-form>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import CountrySelect from '@shared/components/input/input-country-select';
  import { mapActions } from 'vuex';
  import { TrunkService } from '@voice/services/TrunkService';
  import { initSearchStateByPeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';
  import TrunksInputSelectTrunk from '@voice/components/trunks-input-select-trunk';
  import { ExportModalService } from '@voice/modals/ExportModalService';

  export default {
    components: {
      TrunksInputSelectTrunk,
      FilterWrapper,
      CountrySelect
    },
    data() {
      return {
        detailed: true,
        trunks: [],
        form: {
          trunk_id: null,
          call_type: null,
          destination: null,
          destination_b_number: null,
          date: initSearchStateByPeriod(),
          source: null
        }
      };
    },

    mounted() {
      TrunkService.getSelect().then((res) => {
        if (res.length) {
          this.trunks = res;
          this.form.trunk_id = res[0].id;
          this.$nextTick(() => this.submit());
        }
      });
    },

    computed: {
      is_export_allowed() {
        return this.$permission.service_voice_detail_stats_export_is_allowed;
      }
    },

    methods: {
      ...mapActions('voice/stats/detailed', ['search']),
      createExport() {
        ExportModalService.create(this.trunks).on('success', () => this.getAsyncData());
      },
      submit: function () {
        this.$refs.form.validate().then((is_valid) => {
          if (is_valid) {
            const { start, end } = parseSearchStateByPeriod(this.form.date);
            const { trunk_id, destination, destination_b_number, source } = this.form;
            let destination_param = destination_b_number;
            if (destination_b_number) {
              destination_param = destination_b_number;
            } else {
              destination_param = Array.isArray(destination) ? destination.join() : null;
            }
            const params = {
              date_from: start,
              date_to: end,
              trunk_id,
              source,
              destination: destination_param
            };
            this.search(params);
          }
        });
      }
    }
  };
</script>
